import type { ReactNode } from "react";

type AuthCardLayoutProps = {
  heroEyebrow: string;
  heroTitle: string;
  heroDescription: string;
  formEyebrow: string;
  formTitle: string;
  formDescription: string;
  children: ReactNode;
};

export function AuthCardLayout({
  heroEyebrow,
  heroTitle,
  heroDescription,
  formEyebrow,
  formTitle,
  formDescription,
  children,
}: AuthCardLayoutProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 py-10">
      <div className="grid w-full max-w-5xl overflow-hidden rounded-md border border-slate-200 bg-white shadow-[0_18px_55px_rgba(15,23,42,0.08)] lg:grid-cols-[1.05fr_0.95fr]">
        <div className="hidden border-r border-slate-200 bg-slate-50 p-12 lg:flex lg:flex-col lg:justify-between">
          <div className="text-sm font-semibold uppercase tracking-[0.24em] text-slate-900">
            Datascope
          </div>
          <div>
            <div className="max-w-md">
              <div className="text-xs font-semibold uppercase tracking-[0.28em] text-slate-400">
                {heroEyebrow}
              </div>
              <h1 className="mt-4 text-5xl font-semibold tracking-[-0.05em] text-slate-950">
                {heroTitle}
              </h1>
              <p className="mt-5 text-base leading-7 text-slate-600">{heroDescription}</p>
            </div>
          </div>
        </div>

        <div className="p-6 sm:p-10 lg:p-12">
          <div className="mx-auto max-w-md">
            <div className="mb-8 text-sm font-semibold uppercase tracking-[0.24em] text-slate-900 lg:hidden">
              Datascope
            </div>
            <div>
              <div className="text-xs font-semibold uppercase tracking-[0.28em] text-slate-400">
                {formEyebrow}
              </div>
              <h2 className="mt-3 text-4xl font-semibold tracking-[-0.04em] text-slate-950">
                {formTitle}
              </h2>
              <p className="mt-3 text-sm leading-6 text-slate-600">{formDescription}</p>
            </div>

            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
